// extracted by mini-css-extract-plugin
module.exports = {"headerBox":"style_headerBox__Oxlzx","name":"style_name__1HfTi","isOnline":"style_isOnline__2QZXA"};